/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class IconsAPI
 * @hideconstructor
 * @classdesc API class that is used to obtain the icon that is required to be displayed
 */
define([], () => {
	class IconsAPI {

		/**
		 * @function IconsAPI#registerIcons
		 * @description Register the icons from a component
		 * @param {IconObj[]} iconList a list of icons that the component uses.
		 */
		registerIcons(/* icons */) {}

		/**
		 * @function IconsAPI#getIcon
		 * @description Returns an icon from the cache based on the id passed to it
		 * @param {string} iconId Id of the icon
		 * @return {IconObj} object containing the icon details
		 */
		getIcon( /* iconId */ ) {}

	}

	return IconsAPI;
});
